import React from 'react';
import { tap } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Plumbing store',
  synonyms: 'shop store',
  group: 'standardMarker',
  typeUrl: 'plumbing-store',
  icon: {
    baseShape: tap,
    iconColor: '#fff',
    markerColor: '#906BD9',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'general-services',
    order: 5,
  },
  standardMarkerOptions: {
    markerType: 'plumbingStoreMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Plumbing store',
      itemTitleFunction: (item) => (item && item.title) || 'Plumbing store',
    },
    creationOptions: {
      menuText: 'Plumbing store',
      newTitle: 'Plumbing store',
      titlePlaceholder: 'Name of plumbing store',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker indicates a plumbing store location.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Plumbing store',
    description: marker.title,
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
